export const getEventClientDate = (): string => {
    return new Date().toISOString();
};

interface LocationParams {
    path: string;
    _hash: string;
}

export const pageUrlToTriggerLocation = ({
    path,
    _hash,
}: LocationParams): string => {
    if (path.includes('/purchase')) {
        return 'purchase_funnel';
    } else if (path.includes('/refinance')) {
        return 'refinance_funnel';
    }
    return 'homepage';
};
